


















































import EventBus from "./utils/eventBus";
import Http from "@/api/http/fetch/index";
import Toast from "@/components/toast/Toast.vue";
import "@/components/actionSheet/ActionSheet.scss"; //TODO
import "@/components/dialog/Dialog.scss"; //TODO
import LiteSearch from "@/components/liteSearch/LiteSearch.vue";
import * as types from "@/store/constants/types";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import dialogTopContent from "@/components/dialog/arrivalTopContent/arrivalTopContent";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import * as gxPay from "@/api/http/gx/gxPay";
import showOrderNotice from "@/utils/showOrderNotice";
import handleAccordWeightSendNotice from "@/utils/accordWeigthPushNotice.ts";
import hanleNotAccordWeightNotice from "@/utils/notAccordWeightPushNotce.ts";
import GeneralUtilsHelper from "@/utils/generalUtils";
import localStorageHelper from "@/localstorage/localstorage";
import checkinNotiHandler from "@/components/notification/CheckinNotiHandler";
import backgroundCheckinNotiHandler from "@/components/notification/checkNotice.ts";
import BackUpAppToast from "@/components/backUpAppToast/BackUpAppToast.vue";
import recommendOffer from "@/components/recommendOffer/recommendOffer.vue";
import { isIos } from "@/utils/lodash";
import { getFormatDate } from "@/utils/global";
import getNoticeContent from "@/utils/killAppNotice.ts";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import limitCoinFnc from "@/utils/limitCoinShow";
import { Component, Emit, Inject, Model } from "vue-property-decorator";
import { Prop, Provide, Vue, Watch } from "vue-property-decorator";
import SuperPayDialog from "@/components/superPay/superPayDialog/SuperPayDialog.vue";
import SuperPayLaunchToast from "@/components/superPay/superPayLaunchToast/SuperPayLaunchToast.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate" // for vue-router 2.2+
]);

@Component({
  components: {
    Toast,
    LiteSearch,
    BackUpAppToast, //不能异步加载，启动的时候就可能需要
    recommendOffer, //不能异步加载，启动的时候就可能需要
    SuperPayDialog,
    SuperPayLaunchToast,
    dailyCheckIn: () => import("@/views/dailyCheckIn/dailyCheckIn.vue"),
    GetNow: () => import("@/components/getNow/getNow.vue"),
    RateUsToast: () => import("@/components/rateUsToast/rateUsToast.vue"),
    luckyCoinToast: () =>
      import("@/components/luckyCoinToast/luckyCoinToast.vue"),
    LimitCoinToast: () =>
      import("@/components/limitCoinToast/limitCoinToast.vue"),
    DeliveredToast: () =>
      import("@/components/deliveredToast/DeliveredToast.vue"),
    FreeFollowersDialog: () =>
      import("@/components/FreeFollowers/FreeFollowersDialog.vue"),
    BuyVipSendCoin: () =>
      import("@/components/buyVipSendCoin/buyVipSendCoin.vue"),
    RetainVip: () => import("@/components/retainVip/retainVip.vue")
  }
})
export default class App extends Vue {
  @Action(types.ROUTER_GO_BACK) private routerGoBack: any;
  @Getter(types.GETTER_DEVICE_ID) private deviceId: any;
  @Action(types.UPDATE_GX_MASTER_SERVER_DATA)
  private updateMasterServerData: any;
  @Action(types.REQUEST_SUPER_PAY_APP_CONFIG)
  private requestSuperPayAppConfig: any;
  @Getter(types.GETTER_PURCHASED_OFFER) private puchasedOffer: any;
  @Getter(types.GETTER_SUPER_PAY_SHOW_ENABLE) private superPayShowEnable: any;
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG) private superPayAppCoinfig: any;
  @Getter(types.GETTER_INFO_BY_OFFER_DATA) private offerInfo: any;
  @Action(types.DIALOG_SHOW) private dialogShow: any;
  @Action(types.CHECK_SUPER_PAY_APP_INSTALLED)
  private checkSuperPayAppInstalled: any;
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG) private superPayAppConfig: any;
  @Getter(types.GETTER_MASTER_ID) private masterId: any;
  @Getter(types.VIP_RETAIN_DIALOG_SHOW) private vipRetainDialogShow: any;
  @Mutation(types.REPLACE_SUPER_PAY_OFFER_FEED)
  private replaceSuperPayOfferFeed: any;
  @Mutation(types.UPDATE_SUPER_PAY_BUBBLE_STATUS)
  private updateSuperPayBubbleStatus: any;
  @Mutation(types.VIP_RETAIN_DIALOG_CHANGE) private vipRetainDialogChange: any;
  @Mutation(types.UPDATE_STATE_FRONT) private updateStateFront: any;
  @Action(types.SWITCH_FRONT_BACK_TO_CHECK_SUPER_PAY_INSTALL_STATUS)
  private switchFrontBackToCheckSuperPayInstallStatus: any;
  @Action(types.SWITCH_FRONT_BACK_TO_CHECK_BACK_UP_INSTALL_STATUS)
  private switchFrontBackToCheckBackUpAppInstallStatus: any;
  @Action(types.SELECT_APP_STATE) private selectAppState: any;

  private enterTransitionName: string = "";
  private leaveTransitionName: string = "";

  private rateUs: any = {};
  private luckytoast: boolean = false;
  private showLimitCoin: boolean = false;
  private showBuyVipCoin: boolean = false;
  private vipCoinType: boolean = true;

  // private vipRetainParams:any;
  private vipType: any = "";
  private comeFromNotice: boolean = false;
  private vipFrom: any = "";

  //ChallengeRequire需要缓存上次给予的params信息，让用户再次选择
  private includeRoutes: any[] = [
    "PostContainer",
    "FollowersContainer",
    "MoreContainer",
    "OrderDetail",
    "OrderContainer",
    "Home",
    "SubsOrderList",
    "VipCenter"
  ];

  get isPostOffer() {
    return GeneralUtilsHelper.isPostOffer;
  }

  get showVipToast() {
    return this.vipRetainDialogShow;
  }

  private mounted() {
    EventBus.$on("router-transition-type", (content: any) => {
      switch (content) {
        case "back":
          this.enterTransitionName = "animated slideInLeft";
          this.leaveTransitionName = "animated slideOutRight";
          break;
        case "forward":
          this.enterTransitionName = "animated slideInRight";
          this.leaveTransitionName = "animated slideOutLeft";
          break;
        case "down":
          this.enterTransitionName = "animated slideInDown";
          this.leaveTransitionName = "animated slideOutDown";
          break;
        case "up":
          this.enterTransitionName = "animated slideInUp";
          this.leaveTransitionName = "animated slideOutUp";
          break;
        case "static":
          this.enterTransitionName = "";
          this.leaveTransitionName = "";
          break;
        case "fadeIn":
          this.enterTransitionName = "animated fadeIn";
          this.leaveTransitionName = "animated fadeOut";
          break;
        case "fadeOut":
          this.enterTransitionName = "animated-slow fadeIn";
          this.leaveTransitionName = "animated-slow fadeOut";
          break;
        default:
          break;
      }
    });

    EventBus.$on("show-lucky-toast", (val: any) => {
      this.luckytoast = val;
    });

    EventBus.$on("show-rateus-toast", (val: any) => {
      this.rateUs = val;
    });

    EventBus.$on("show-limit-coin", (val: any) => {
      this.showLimitCoin = val;
    });

    EventBus.$on("show-buy-Vip-send-coin", (val: any) => {
      this.showBuyVipCoin = val.show;
      this.vipCoinType = val.type;
    });

    EventBus.$on("show-retain-vip", (val: any) => {
      this.vipRetainDialogChange(val.show);
      this.vipType = val.type;
      this.comeFromNotice = val.fromNotice;
      this.vipFrom = val.from;

      if (val.show) {
        sendEvent("uia_vip_1mo_show", "retain_box");
        sendEventWithParams("uia_vip_pop_show", { VIP_A: "retain" });
      }
    });

    setTimeout(() => {
      //请求一次订单列表接口，判断是否有processing的订单
      gxPay.getOrder(this.deviceId, "").catch((error: any) => {});
    }, 5000);

    AppLifeCycle.addListener({
      key: "app",
      fn: async () => {
        if (this.masterId || this.deviceId) {
          setTimeout(() => this.updateMasterServerData(), 1500);
        }
        limitCoinFnc.isShowlimiteCoin();
        const appVersionOk = localStorageHelper.get("is_app_version_ok");
        if (appVersionOk && isIos()) {
          setTimeout(() => {
            const nativaData = getNoticeContent.calcNoticeData();
            const toNativaData = nativaData.includes("&")
              ? nativaData
              : nativaData + "&";
            // Http.TerminateData(toNativaData);
          }, 12000);
        }

        this.updateStateFront(true);

        this.switchFrontBackToCheckSuperPayInstallStatus();
        this.switchFrontBackToCheckBackUpAppInstallStatus();

        await Http.ADConnect(); //安卓说要频繁调用
        this.selectAppState();
      }
    });

    AppLifeCycle.addGoBackListener({
      key: "goBackGround",
      fn: async () => {
        const appVersionOk = localStorageHelper.get("is_app_version_ok");
        const processingNotice = localStorageHelper.get(
          "order-processing-data"
        );
        if (!appVersionOk) {
          if (processingNotice) {
            Http.ShowNotification(processingNotice);
            //注册了通知，表示今天发过porcessing的通知了
            localStorageHelper.set(
              "send_processing_notice_today",
              getFormatDate(new Date(), "yyyy/MM/dd")
            );
          }
        }

        if (appVersionOk) {
          //根据权重随机消息
          const data1 = handleAccordWeightSendNotice.getsendRandomNoticeData();
          //不根据权重随机的消息
          const data2 = hanleNotAccordWeightNotice.getSendNoticeContent();
          //签到的通知
          const data3 = backgroundCheckinNotiHandler.configNotification();
          //order processing通知
          let data4 = "";
          if (processingNotice) {
            data4 = "&" + JSON.stringify(processingNotice);
            localStorageHelper.set(
              "send_processing_notice_today",
              getFormatDate(new Date(), "yyyy/MM/dd")
            );
          }
          //去掉最前面的&
          const data = (data1 + data2 + data3 + data4).substr(1);
          if (isIos()) {
            Http.ShowBatchNotification(data);
          } else {
            try {
              const list = data.split("&");
              Http.CancelLocalNotification();
              for (const i of list) {
                const m = JSON.parse(i);
                if (m.imageUrl) {
                  m.imageUrl =
                    "https://cdn.soupep.com/img/notification/" +
                    m.imageUrl +
                    ".png";
                }
                Http.ShowNotification(m);
              }
            } catch (err) {}
          }
        }

        localStorageHelper.remove("order-processing-data");
        this.updateStateFront(false);
      }
    });
    const el: any = document.getElementById("body_splash");
    el.style.display = "none";
  }
}
